import { style } from 'typestyle'
import { important } from 'csx'
export const pt8i = style({ paddingTop: important('8px') })
